import axios from 'axios';
import { getAccessToken, getRefreshToken, setTokens, clearAuth } from '../utils/auth';
import { API_URL } from '../utils/constants';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const refresh = getRefreshToken();
        if (!refresh) throw new Error('No refresh token');
        const res = await axios.post(`${API_URL}/auth/token/refresh/`, { refresh });
        setTokens(res.data.access, res.data.refresh || refresh);
        original.headers.Authorization = `Bearer ${res.data.access}`;
        return api(original);
      } catch {
        clearAuth();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
